export default {
    PRINTERS: 'printers',

    all() {
        return [
            this.PRINTERS,
        ]
    },

    isEnabled(feature, enabledFeatures) {
        return enabledFeatures.includes(feature)
    }
}
